import React, {Component} from "react";
import {Table} from "reactstrap";
import UserService from "../services/user-service";
import ReactPaginate from "react-paginate";

export class AppUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: []
        }
    }


    componentDidMount = () => {
        this.fetchUsers(0);
    }

    handlePageChange = (page) => {
        this.fetchUsers(page.selected);
    }

    fetchUsers = async (page) => {
        let params = {
            keyword: "",
            appName: this.props.appName,
            per_page: 50,
            page: page
        }

        let response = await UserService.getUsersByCriteria(params);
        const totalPages = Math.round(response.total_users / 50);
        console.log(JSON.stringify(response));
        this.setState({
            users: response.users,
            total_pages: totalPages,
            page: 0
        });
    }


    render() {
        return (
            <div>
                <Table>
                    <thead>
                    <tr>
                        <th className="width-30">NAME</th>
                        <th className="width-70">EMAIL</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.users.length > 0 &&
                    this.state.users.map((item, i) => {
                        return (
                            <tr key={i}>
                                <td className="width-30">{item.firstName} {item.lastName}</td>
                                <td className="width-30">{item.email}</td>
                            </tr>
                        );
                    })
                    }
                    </tbody>
                </Table>
                <ReactPaginate previousLabel={"‹"}
                               nextLabel={"›"}
                               breakLabel={<a>...</a>}
                               breakClassName={"ellipsis disabled"}
                               forcePage={+(this.state.page)}
                               onPageChange={this.handlePageChange}
                               pageCount={this.state.total_pages}
                               marginPagesDisplayed={1}
                               pageRangeDisplayed={3}
                               containerClassName={"pagination"}
                               subContainerClassName={"pages pagination"}
                               activeClassName={"active"}
                />
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/user-search/AppUsers.js